import { z } from 'zod';
// Define Zod schemas based on the existing types
const allergenValues = [
    'gluten',
    'crustaceans',
    'eggs',
    'fish',
    'peanuts',
    'soy',
    'dairy',
    'nuts',
    'celery',
    'mustard',
    'sesame',
    'sulphites',
    'lupin',
    'molluscs',
];
const AllergenEnum = z.enum(allergenValues);
const ingredientUnitValues = ['kg', 'l', 'ud', 'g', 'ml'];
export const IngredientUnitEnum = z.enum(ingredientUnitValues);
export const QuantityPerProductionDescription = `
        Quantity per production, only set if explicitly mentioned.
        When handling units:
        - For weight measurements (g, kg):
          * Always convert to kg (e.g., "400g" should be 0.4 kg)
        - For volume measurements (ml, l):
          * Always convert to l (e.g., "500ml" should be 0.5 l)
        - For units ("ud"):
          * Keep the exact number as is
    `;
export const RecipeIngredientSchema = z.object({
    name: z.string().describe('Name of the ingredient'),
    quantityPerProduction: z.number().nullable().optional().describe(QuantityPerProductionDescription),
    unit: IngredientUnitEnum.describe('Unit of the ingredient, if not explicitly specified, it should depend on how is usually the ingredient mesured')
        .nullable()
        .optional(),
    pricePerUnit: z.number().nullable().optional().describe('Price per unit, only set if explicitly mentioned'),
});
const PreparationSchema = z.object({
    prePreparation: z
        .array(z.string())
        .nullable()
        .describe('Pre-preparation steps, those cuts and elaborations that need to be done before the preparation'),
    preparation: z.array(z.string()).nullable().describe('Steps to prepare the recipe'),
    conservation: z.array(z.string()).nullable().describe('Steps to conserve the recipe'),
});
export const BaseRecipeSchema = z.object({
    name: z.string().describe('Name of the recipe, first letter uppercase'),
    allergens: z
        .array(AllergenEnum)
        .nullable()
        .optional()
        .describe('Allergens of the recipe. Interpreted from ingredients, preparation steps and name of the recipe'),
    unit: IngredientUnitEnum.describe('Mesurement unit of the recipe, if not specified, it should depend on how is usually the recipe mesured')
        .nullable()
        .optional(),
    productionAmount: z
        .number()
        .nullable()
        .describe('Production amount of the recipe based on amount of the ingredients, the unit and the elaboration steps'),
    productionTime: z.number().nullable().describe('Production time of the recipe in minutes'),
    pvp: z.number().nullable().describe('Sell price per unit of the recipe, only set if explicitly mentioned'),
    servingsPerProduction: z
        .number()
        .nullable()
        .describe('Number of servings per production, only set if explicitly mentioned'),
    priceVariation: z.number().nullable().describe('Price variation of the recipe, only set if explicitly mentioned'),
    inMenu: z.boolean().nullable().describe('If the recipe is in the menu, only set if explicitly mentioned'),
    ingredients: z.array(RecipeIngredientSchema).nullable().describe('Ingredients of the recipe'),
    preparation: PreparationSchema.nullable().describe('Preparation steps of the recipe'),
});
export const buildRecipeWithCategoriesSchema = (recipeCategories) => {
    const categoryField = recipeCategories.length > 0
        ? z
            .array(z.enum(recipeCategories.map(cat => cat.name)))
            .describe('Categories of the recipe. Can include multiple categories if the user mentions them')
            .optional()
            .nullable()
        : z
            .array(z.string())
            .describe('Category names of the recipe (will be converted to IDs later). Set this field if the user mentions any category for the recipe. Can include multiple categories.')
            .optional()
            .nullable();
    return BaseRecipeSchema.extend({
        categories: categoryField,
    });
};
//# sourceMappingURL=BaseRecipeSchema.js.map